import { render, staticRenderFns } from "./Arcade.vue?vue&type=template&id=4d3c42cd&scoped=true"
import script from "./Arcade.vue?vue&type=script&lang=js"
export * from "./Arcade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c42cd",
  null
  
)

export default component.exports